import React from 'react'
import { GiHamburgerMenu } from "react-icons/gi";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import styled from 'styled-components';
import { theme } from '../../../theme/theme';
import { 
  Box, List, Divider, ListItemIcon, ListItemButton, ListItem, ListItemText
} from '@mui/material';
import { StyledLogo } from '../styled';
import { useSelector } from 'react-redux';
import wisenrollLogo from '../../../assets/images/login/wisenrolIcon.png'
import { AiFillAccountBook, AiFillBell  } from "react-icons/ai";

const { sixth, sixthHover, third, thirdHover, first, firstHover } = theme

const BurgerMenu = styled(GiHamburgerMenu)`
  color: ${sixth};
  font-size: 26px;

  &:hover {
    color: ${sixthHover}
  }

`

const MenuContainer = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
`

export const OptionsMenu = ({
  options
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuContainer>
      <Button
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open}
        onClick={handleClick}
      >
        <BurgerMenu/>
      </Button>
      <Menu
        id="fade-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'fade-button',
          },
        }}
        slots={{ transition: Fade }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {
          options.map(option => {
            return (
              <MenuItem onClick={option?.onClick}>{option?.text}</MenuItem>
            )
          })
        }
      </Menu>
    </MenuContainer>
  );
}


export const OptionsMenuDrawer = ({
  handleClick
}) => {


  return (
    <MenuContainer>
      <Button
        onClick={handleClick}
      >
        <BurgerMenu/>
      </Button>
    </MenuContainer>
  );
}

export const DrawerContent = ({
  toggleDrawer,
  options
}) => {
  const { selectedProduct } = useSelector(state => state.user);
  const [imgSrc, setImgSrc] = React.useState(/* selectedProduct?.image_ads  */wisenrollLogo)

  const onError = () => {
    console.log('error on logo')
    setImgSrc(wisenrollLogo)
  }

  return (
    <Box sx={{ width: 'max-content' }} role="presentation" onClick={() => toggleDrawer(false)}>
      <StyledLogo
        rel="preload"
        src={ imgSrc }
        customPosition={'static'}
        customHeight={55}
        onError={onError}
      />
      <Divider />
      <List>
        {options?.map((option, index) => (
          <ListItem key={option?.text} disablePadding>
            <ListItemButton 
              onClick={option?.onClick}
            >
              <ListItemIcon>
                <option.icon />               
              </ListItemIcon>
              <ListItemText 
                primary={option?.text} 
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: `${first}`,
                    fontFamily: 'Arial, sans-serif',

                    '&:hover': {
                      color: `${firstHover}`
                    }
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
);
} 